import type { TestId } from '@repo/test-id';
import { CheckIcon } from '@repo/icons';
import { tr } from '@repo/locale';
import classNames from 'classnames';

interface Props {
  label: string;
  fulfilled: boolean;
  onClick: () => void;
  testId: TestId;
}

export default function ActivationChecklistItem({ label, fulfilled, onClick, testId }: Props) {
  return (
    <div className="flex flex-row items-center gap-2 text-left" data-testid={testId}>
      <div className="shrink-0">
        {fulfilled ? (
          <div className="bg-teal rounded-3xl text-white" data-testid={testId.append('fulfilled')}>
            <CheckIcon size={20} />
          </div>
        ) : (
          <div className="h-5 w-5 rounded-3xl bg-white" data-testid={testId.append('notFulfilled')} />
        )}
      </div>
      <div
        className={classNames('grow text-sm text-balance', {
          'text-body-subtle line-through': fulfilled,
          'text-heading': !fulfilled,
        })}
      >
        {label}
      </div>
      {!fulfilled && (
        <button
          className="text-fg-warning cursor-pointer text-xs"
          type="button"
          onClick={onClick}
          data-testid={testId.append('fulfill')}
        >
          {tr('owned_parking_manage:parking_statuses.draft.activation.cant_request.action')}
        </button>
      )}
    </div>
  );
}
